/* ============================================================
   Announcement Bar — Auto Rotate (Updated)
   Reads rotation delay from data-delay attribute
   Respects data-autoplay attribute
   ============================================================ */
(function () {
  var track = document.querySelector('.announcement-bar__track');
  if (!track) return;

  var autoplay = track.getAttribute('data-autoplay');
  if (autoplay === 'false') return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = track.querySelectorAll('.announcement-bar__item');
  if (!items || items.length < 2) return;

  var delay = parseInt(track.getAttribute('data-delay'), 10) || 3500;
  var current = 0;

  setInterval(function () {
    var next = (current + 1) % items.length;

    items[current].classList.add('is-exit');
    items[current].classList.remove('is-active');
    items[current].setAttribute('aria-hidden', 'true');

    items[next].classList.add('is-active');
    items[next].setAttribute('aria-hidden', 'false');

    var prev = current;
    setTimeout(function () {
      items[prev].classList.remove('is-exit');
    }, 500);

    current = next;
  }, delay);
})();

/* ============================================================
   LAZY VIDEO LOADER — IntersectionObserver
   Used by:
     - sections/see-it-for-yourself.liquid  (.sify-video)
     - sections/how-it-works.liquid         (.hiw-video)
   Marker:
     - video[data-lazy-video]          → element opts in
     - data-autoplay-in-view="true"    → play() on intersect
     - <source data-src="…">           → src promoted on intersect
     - <video  data-src="…">           → element's own src promoted

   Goal: keep initial payload close to zero (poster only). Sources
   attach + load() only when the video enters the viewport, and the
   video pauses again when it leaves.

   Exposes window.SSLazyVideo.{attach,play} so existing play/pause
   handlers can demand-load sources when a user clicks before the
   observer has fired.
   ============================================================ */
(function () {
  'use strict';

  function attachSources(video) {
    if (!video || video.dataset.lazySrcAttached === 'true') return;

    var pending = video.querySelectorAll('source[data-src]');
    if (pending.length) {
      pending.forEach(function (s) {
        var url = s.getAttribute('data-src');
        if (url && !s.getAttribute('src')) s.setAttribute('src', url);
      });
    } else if (video.dataset.src) {
      video.setAttribute('src', video.dataset.src);
    }

    video.dataset.lazySrcAttached = 'true';
    try { video.load(); } catch (e) { /* noop */ }
  }

  function safePlay(video) {
    /* muted + playsinline are already set in markup — required for
       autoplay on iOS Safari. Re-assert muted just in case. */
    if (video.hasAttribute('muted')) video.muted = true;
    var p;
    try { p = video.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  /* Public helpers — used by play/pause click handlers below. */
  window.SSLazyVideo = {
    attach: attachSources,
    play: function (video) {
      attachSources(video);
      safePlay(video);
    }
  };

  var videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  /* No IntersectionObserver (very old browsers) — degrade by
     loading + playing immediately so nothing breaks. */
  if (typeof IntersectionObserver === 'undefined') {
    videos.forEach(function (v) {
      attachSources(v);
      if (v.dataset.autoplayInView === 'true') safePlay(v);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;

      if (entry.isIntersecting) {
        attachSources(v);
        if (v.dataset.autoplayInView === 'true') safePlay(v);
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, {
    /* Slight rootMargin so the source has a moment to buffer before
       the card is fully in view. Threshold keeps offscreen siblings
       in a horizontal slider from all firing at once. */
    threshold: 0.25,
    rootMargin: '100px 0px'
  });

  videos.forEach(function (v) { observer.observe(v); });

  /* Pause anything still playing when the tab is hidden — saves
     mobile battery and bandwidth without affecting visible UX. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      videos.forEach(function (v) { if (!v.paused) v.pause(); });
    }
  });
})();

/* ============================================================
   HEADER CUSTOM NAV — CLEAN BUILD
   Uses fully custom HTML classes (.header__nav-item--has-mega,
   .header__nav-link) — NOT Dawn's <details>/<summary> pattern.
   Guard added: skips if trigger is inside a <details> element.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 990;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  /* Open a dropdown */
  function openDropdown(trigger, panel) {
    if (trigger && trigger.closest('details')) return;
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }

  /* Close a dropdown */
  function closeDropdown(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  }

  /* Close all dropdowns */
  function closeAll() {
    document.querySelectorAll('.header__nav-link').forEach(function (t) {
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (t && p) closeDropdown(t, p);
    });
  }

  /* Init nav items */
  var navItems = document.querySelectorAll(
    '.header__nav-item--has-mega, .header__nav-item--has-std'
  );

  navItems.forEach(function (item) {
    var trigger = item.querySelector('.header__nav-link');
    if (!trigger) return;
    var panelId = trigger.getAttribute('aria-controls');
    if (!panelId) return;
    var panel = document.getElementById(panelId);
    if (!panel) return;

    var hoverTimer = null;

    /* Open immediately on item enter */
    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      openDropdown(trigger, panel);
    });

    /* Delay close so cursor can move to panel */
    item.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      hoverTimer = setTimeout(function () {
        closeDropdown(trigger, panel);
      }, 150);
    });

    /* If cursor enters panel — cancel close timer */
    if (panel) {
      panel.addEventListener('mouseenter', function () {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      });

      /* Close when cursor leaves panel */
      panel.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        hoverTimer = setTimeout(function () {
          closeDropdown(trigger, panel);
        }, 100);
      });
    }

    /* Keyboard support */
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var open = trigger.getAttribute('aria-expanded') === 'true';
        if (open) {
          closeDropdown(trigger, panel);
        } else {
          closeAll();
          openDropdown(trigger, panel);
        }
      }
      if (e.key === 'Escape') {
        closeDropdown(trigger, panel);
        trigger.focus();
      }
    });
  });

  /* Click outside — close all */
  document.addEventListener('click', function (e) {
    if (!e.target.closest(
      '.header__nav-item--has-mega, .header__nav-item--has-std'
    )) {
      closeAll();
    }
  });

  /* Close all on resize to mobile */
  window.addEventListener('resize', function () {
    if (!isDesktop()) closeAll();
  });

})();

/* ============================================================
   Trust Bar — Count-Up Animation
   Uses IntersectionObserver to animate stat numbers on scroll.
   Scoped to trust-bar section, skips clone elements.
   ============================================================ */
(function () {
  'use strict';

  if (!window.IntersectionObserver) return;

  var counters = document.querySelectorAll('[data-count]');
  if (!counters.length) return;

  var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;
        observer.unobserve(el);

        var target = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
        var useSeparator = el.getAttribute('data-separator') === 'true';
        var duration = 1600;
        var startTime = null;

        function animate(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = eased * target;

          var display = current.toFixed(decimals);
          if (useSeparator) {
            var parts = display.split('.');
            parts[0] = parseInt(parts[0], 10).toLocaleString('en-US');
            display = parts.join('.');
          }

          el.textContent = display + suffix;

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            var final = target.toFixed(decimals);
            if (useSeparator) {
              var finalParts = final.split('.');
              finalParts[0] = parseInt(finalParts[0], 10).toLocaleString('en-US');
              final = finalParts.join('.');
            }
            el.textContent = final + suffix;
          }
        }

        requestAnimationFrame(animate);
      });
  }, { threshold: 0.3 });

  counters.forEach(function (el) {
    if (!el.closest('.trust-marquee-clone')) {
      observer.observe(el);
    }
  });
})();

/* ============================================================
   HOW IT WORKS — Interactive Hotspot Logic
   Scoped per section via querySelectorAll('.hiw-section')
   ============================================================ */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.hiw-section');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var dots = section.querySelectorAll('.hiw-dot');
    var steps = section.querySelectorAll('.hiw-step-clickable');
    var tooltip = section.querySelector('.hiw-tooltip');

    if (!dots.length) return;

    function clearAll() {
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      if (tooltip) tooltip.classList.remove('is-visible');
    }

    function activate(featureNum) {
      clearAll();

      var activeDot = section.querySelector('.hiw-dot[data-feature="' + featureNum + '"]');
      var activeStep = section.querySelector('.hiw-step-clickable[data-feature="' + featureNum + '"]');

      if (activeDot) activeDot.classList.add('is-active');
      if (activeStep) {
        activeStep.classList.add('is-active');
        activeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      if (tooltip && activeDot) {
        var title = activeDot.getAttribute('data-tooltip-title') || '';
        var desc = activeDot.getAttribute('data-tooltip-desc') || '';

        if (title || desc) {
          tooltip.innerHTML = '<strong>' + title + '</strong><br>' + desc;

          var dotRect = activeDot.getBoundingClientRect();
          var wrapRect = activeDot.closest('.hiw-video-wrap').getBoundingClientRect();

          var left = dotRect.left - wrapRect.left + 20;
          var top = dotRect.top - wrapRect.top - 8;
          var tipW = 200;

          if (left + tipW > wrapRect.width) left = wrapRect.width - tipW - 8;
          if (left < 0) left = 8;

          tooltip.style.left = left + 'px';
          tooltip.style.top = top + 'px';
          tooltip.classList.add('is-visible');
        }
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var f = this.getAttribute('data-feature');
        if (this.classList.contains('is-active')) {
          clearAll();
        } else {
          activate(f);
        }
      });
    });

    steps.forEach(function (step) {
      step.addEventListener('click', function (e) {
        e.stopPropagation();
        activate(this.getAttribute('data-feature'));
      });
    });

    document.addEventListener('click', function (e) {
      if (
        !e.target.closest('.hiw-video-wrap') &&
        !e.target.closest('.hiw-feature-group')
      ) {
        clearAll();
      }
    });
  });
})();

/* ============================================================
   initDotSlider — Reusable Slider Utility (scoped in IIFE)
   Used by: Clinician Endorsements, Surgeon's Bundle,
   See It For Yourself — and any section that needs a
   dot-navigated slider.

   cfg = {
     trackId, dotsId, itemSelector, dotClass,
     getPerView: fn(), getGap: fn()
   }
   ============================================================ */
(function () {
'use strict';

function initDotSlider(cfg) {

  var track = document.getElementById(cfg.trackId);
  var dotsWrap = document.getElementById(cfg.dotsId);
  if (!track || !dotsWrap) return;

  var items = Array.from(track.querySelectorAll(cfg.itemSelector));
  var current = 0;

  function perView() { return cfg.getPerView ? cfg.getPerView() : 1; }
  function gap() { return cfg.getGap ? cfg.getGap() : 0; }

  function buildDots() {
    dotsWrap.innerHTML = '';
    var pv = perView();
    var n = Math.max(1, items.length - pv + 1);

    dotsWrap.style.display = n <= 1 ? 'none' : '';

    for (var i = 0; i < n; i++) {
      var btn = document.createElement('button');
      btn.className = cfg.dotClass + (i === current ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Slide ' + (i + 1));
      btn.dataset.index = i;
      btn.addEventListener('click', function () {
        slideTo(+this.dataset.index);
      });
      dotsWrap.appendChild(btn);
    }
  }

  function slideTo(index) {
    var pv = perView();
    var n = Math.max(1, items.length - pv + 1);
    current = Math.max(0, Math.min(index, n - 1));

    var itemWidth = items[0] ? items[0].offsetWidth : 0;
    track.style.transform = 'translateX(-' + current * (itemWidth + gap()) + 'px)';

    dotsWrap.querySelectorAll('.' + cfg.dotClass).forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === current);
    });
  }

  var dragStartX = 0, dragging = false, threshold = 50;

  function onDragStart(x) {
    dragStartX = x;
    dragging = true;
    track.style.transition = 'none';
  }
  function onDragEnd(x) {
    if (!dragging) return;
    dragging = false;
    track.style.transition = '';
    var diff = dragStartX - x;
    if (diff > threshold) slideTo(current + 1);
    else if (diff < -threshold) slideTo(current - 1);
    else slideTo(current);
  }

  track.addEventListener('touchstart', function (e) {
    onDragStart(e.touches[0].clientX);
  }, { passive: true });
  track.addEventListener('touchend', function (e) {
    onDragEnd(e.changedTouches[0].clientX);
  }, { passive: true });
  track.addEventListener('mousedown', function (e) {
    onDragStart(e.clientX);
    e.preventDefault();
  });
  window.addEventListener('mouseup', function (e) {
    if (dragging) onDragEnd(e.clientX);
  });

  var resizeTimer;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      current = 0;
      buildDots();
      slideTo(0);
    }, 200);
  });

  buildDots();
  slideTo(0);
}

/* ============================================================
   Clinician Endorsements — Reel Slider Init
   ============================================================ */
(function () {
  document.querySelectorAll('.ce-slider').forEach(function (sliderEl) {
    var sectionId = sliderEl.getAttribute('data-section-id');
    var reelCount = parseInt(sliderEl.getAttribute('data-reel-count'), 10) || 0;

    initDotSlider({
      trackId: 'ceReelTrack-' + sectionId,
      dotsId: 'ceReelDots-' + sectionId,
      itemSelector: '.ce-reel-card',
      dotClass: 'dot-slider__dot',

      getPerView: function () {
        var w = window.innerWidth;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return reelCount > 3 ? 3 : reelCount;
      },

      getGap: function () {
        return 16;
      }
    });
  });
})();

/* ============================================================
   SURGEON'S BUNDLE
   1. Slider — uses existing initDotSlider() utility
   2. Variant selector — updates CTA href on click
   ============================================================ */
(function () {
  'use strict';

  /* ── 1. Slider — only fires when .sb-products-track exists (> 3 components) ── */
  document.querySelectorAll('.sb-products-track').forEach(function (track) {
    var sectionId = track.getAttribute('data-section-id');

    initDotSlider({
      trackId: 'sbTrack-' + sectionId,
      dotsId: 'sbDots-' + sectionId,
      itemSelector: '.sb-product-card',
      dotClass: 'dot-slider__dot',

      getPerView: function () {
        var w = window.innerWidth;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return 3;
      },

      getGap: function () {
        return 24;
      }
    });
  });

})();

/* ============================================================
   PRODUCT ECOSYSTEM — Dot Navigation for Dawn SliderComponent
   Builds dots per visible page. Syncs via IntersectionObserver.
   Rebuilds on resize to handle breakpoint changes.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('.pe-dots').forEach(function (dotsWrap) {
    var sliderId = dotsWrap.getAttribute('data-slider-id');
    var desktopCols = parseInt(dotsWrap.getAttribute('data-columns'), 10) || 4;

    var slider = document.getElementById(sliderId);
    if (!slider) return;

    var items = slider.querySelectorAll('.grid__item');
    var total = items.length;
    var currentActive = 0;

    function getVisibleCols() {
      if (!items.length) return 1;
      var sliderWidth = slider.clientWidth;
      var firstItem   = items[0];
      var itemOffset  = items.length > 1
        ? items[1].offsetLeft - firstItem.offsetLeft
        : firstItem.offsetWidth;
      if (!sliderWidth || !itemOffset) {
        var w = window.innerWidth;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return desktopCols;
      }
      return Math.max(1, Math.round(sliderWidth / itemOffset));
    }

    function getItemOffset() {
      if (items.length < 2) return items.length ? items[0].offsetWidth : 0;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function scrollToIndex(idx) {
      var itemOffset = getItemOffset();
      if (!itemOffset) return;
      // Direct scrollLeft assignment animates via the slider's CSS
      // `scroll-behavior: smooth` and works consistently across mobile
      // browsers (including iOS Safari, which ignores the `behavior`
      // option on scrollTo).
      slider.scrollLeft = idx * itemOffset;
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      var cols = getVisibleCols();
      var pageCount = Math.max(1, total - cols + 1);
      currentActive = 0;

      if (pageCount <= 1) {
        dotsWrap.style.display = 'none';
        return;
      }
      dotsWrap.style.display = '';

      for (var i = 0; i < pageCount; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dot-slider__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.dataset.index = i;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToIndex(+this.dataset.index);
        });
        dotsWrap.appendChild(btn);
      }
    }

    function updateActiveDot(idx) {
      var cols = getVisibleCols();
      var pageCount = Math.max(1, total - cols + 1);
      var activeIdx = Math.min(Math.max(0, idx), pageCount - 1);
      if (activeIdx === currentActive) return;
      currentActive = activeIdx;
      dotsWrap.querySelectorAll('.dot-slider__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIdx);
      });
    }

    /* Sync active dot to slider scroll position. We compute the page from
       scrollLeft / itemOffset, so the dot tracks the leftmost visible card,
       not whichever item most recently entered view. */
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var itemOffset = getItemOffset();
        if (!itemOffset) return;
        updateActiveDot(Math.round(slider.scrollLeft / itemOffset));
      }, 30);
    }, { passive: true });

    /* Rebuild on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 200);
    });

    /* Rebuild whenever the slider's width settles (handles initial paint,
       font/image loads, breakpoint changes, parent layout shifts). */
    if (typeof ResizeObserver !== 'undefined') {
      var roTimer;
      var ro = new ResizeObserver(function () {
        clearTimeout(roTimer);
        roTimer = setTimeout(buildDots, 50);
      });
      ro.observe(slider);
    }

    /* Build once now, again after first paint, and again on full load
       — so we have correct dimensions even if the script ran early. */
    buildDots();
    requestAnimationFrame(buildDots);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', buildDots, { once: true });
    }
  });
})();

/* ============================================================
   SEE IT FOR YOURSELF — Reel Slider + Sound Toggle
   Uses initDotSlider() — already defined above
   ============================================================ */
(function () {
  'use strict';

  function muteAllSify(track) {
    track.querySelectorAll('video').forEach(function (v) {
      if (!v.muted) v.muted = true;
    });
    track.querySelectorAll('.sify-sound-btn i').forEach(function (i) {
      i.className = 'ph ph-speaker-slash';
    });
  }

  /* ── Slider — fires for all .sify-track elements ── */
  document.querySelectorAll('.sify-track').forEach(function (track) {
    var sectionId = track.getAttribute('data-section-id');
    var reelCount = parseInt(track.getAttribute('data-reel-count'), 10) || 0;

    initDotSlider({
      trackId: 'sifyTrack-' + sectionId,
      dotsId: 'sifyDots-' + sectionId,
      itemSelector: '.sify-reel-card',
      dotClass: 'dot-slider__dot',

      getPerView: function () {
        var w = window.innerWidth;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return reelCount > 4 ? 4 : reelCount;
      },

      getGap: function () {
        return 16;
      }
    });

    if (typeof MutationObserver !== 'undefined') {
      var lastTransform = track.style.transform || '';
      var mo = new MutationObserver(function () {
        var current = track.style.transform || '';
        if (current !== lastTransform) {
          lastTransform = current;
          muteAllSify(track);
        }
      });
      mo.observe(track, { attributes: true, attributeFilter: ['style'] });
    }
  });

  /* ── Sound toggle — one active at a time, scoped per section ── */
  document.querySelectorAll('.sify-sound-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      var sectionId = btn.getAttribute('data-section-id');
      var card = btn.closest('.sify-reel-card');
      var video = card ? card.querySelector('video') : null;
      var icon = btn.querySelector('i');

      if (!video) return;

      if (video.muted) {
        /* Mute all other videos in this section */
        document.querySelectorAll(
          '[data-section-id="' + sectionId + '"] video'
        ).forEach(function (v) {
          v.muted = true;
        });

        /* Reset all icons to muted */
        document.querySelectorAll(
          '[data-section-id="' + sectionId + '"] .sify-sound-btn i'
        ).forEach(function (i) {
          i.className = 'ph ph-speaker-slash';
        });

        /* Unmute this video */
        video.muted = false;
        icon.className = 'ph ph-speaker-high';
      } else {
        video.muted = true;
        icon.className = 'ph ph-speaker-slash';
      }
    });
  });

})();

/* ============================================================
   CR Clinician Reels — Reel Slider
   Uses initDotSlider() — already defined above
   ============================================================ */
(function () {
  'use strict';

  function muteAllCrReels(track) {
    track.querySelectorAll('video').forEach(function (v) {
      if (!v.muted) v.muted = true;
    });
    track.querySelectorAll('.ce-sound-btn i').forEach(function (i) {
      i.className = 'ph ph-speaker-slash';
    });
  }

  document.querySelectorAll('.cr-reels-track').forEach(function (track) {
    var sectionId = track.getAttribute('data-section-id');
    var reelCount = parseInt(track.getAttribute('data-reel-count'), 10) || 0;
    var colsDesktop = parseInt(track.getAttribute('data-cols-desktop'), 10) || 3;

    initDotSlider({
      trackId: 'crReelsTrack-' + sectionId,
      dotsId: 'crReelsDots-' + sectionId,
      itemSelector: '.cr-reel-card',
      dotClass: 'dot-slider__dot',

      getPerView: function () {
        var w = window.innerWidth;
        if (w < 750) return 1;
        if (w < 990) return 2;
        return reelCount > colsDesktop ? colsDesktop : reelCount;
      },

      getGap: function () {
        return 24;
      }
    });

    if (typeof MutationObserver !== 'undefined') {
      var lastTransform = track.style.transform || '';
      var mo = new MutationObserver(function () {
        var current = track.style.transform || '';
        if (current !== lastTransform) {
          lastTransform = current;
          muteAllCrReels(track);
        }
      });
      mo.observe(track, { attributes: true, attributeFilter: ['style'] });
    }
  });
})();

})(); /* end initDotSlider enclosing IIFE */

/* ============================================================
   Clinician Endorsements — Sound Toggle
   ============================================================ */
(function () {
  'use strict';

  function setBtnIcon(btn, muted) {
    var icon = btn && btn.querySelector('i');
    if (!icon) return;
    icon.className = muted ? 'ph ph-speaker-slash' : 'ph ph-speaker-high';
  }

  function muteAllReels() {
    document.querySelectorAll('.ce-reel-video').forEach(function (v) {
      if (!v.muted) v.muted = true;
      var w = v.closest('.ce-reel-wrap');
      if (w) setBtnIcon(w.querySelector('.ce-sound-btn'), true);
    });
  }

  document.querySelectorAll('.ce-reel-track').forEach(function (track) {
    if (typeof MutationObserver === 'undefined') return;
    var lastTransform = track.style.transform || '';
    var mo = new MutationObserver(function () {
      var current = track.style.transform || '';
      if (current !== lastTransform) {
        lastTransform = current;
        muteAllReels();
      }
    });
    mo.observe(track, { attributes: true, attributeFilter: ['style'] });
  });

  document.querySelectorAll('.ce-sound-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.ce-reel-wrap');
      if (!wrap) return;
      var video = wrap.querySelector('video');
      if (!video) return;

      var willUnmute = video.muted;

      if (willUnmute) {
        document.querySelectorAll('.ce-reel-video').forEach(function (other) {
          if (other === video) return;
          other.muted = true;
          var otherWrap = other.closest('.ce-reel-wrap');
          if (otherWrap) setBtnIcon(otherWrap.querySelector('.ce-sound-btn'), true);
        });
        video.muted = false;
      } else {
        video.muted = true;
      }

      setBtnIcon(btn, video.muted);
    });
  });
})();

/* ============================================================
   Clinician Endorsements — Play / Pause Toggle
   ============================================================ */
(function () {
  'use strict';
  document.querySelectorAll('.ce-play-btn').forEach(function (btn) {
    var wrap = btn.closest('.ce-reel-wrap');
    if (!wrap) return;
    var video = wrap.querySelector('video');
    if (!video) return;

    function syncState() {
      var icon = btn.querySelector('i');
      if (icon) {
        icon.className = video.paused
          ? 'ph ph-play'
          : 'ph ph-pause';
      }
      btn.classList.toggle('is-paused', video.paused);
    }

    btn.addEventListener('click', function () {
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    syncState();

    if (video.autoplay && video.paused) {
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  });
})();

/* ============================================================
   See It For Yourself — Play / Pause Toggle
   Lazy-loading is handled by the LAZY VIDEO LOADER block above.
   This block only wires the on-card play/pause button and keeps
   its icon in sync with the underlying <video> state.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('.sify-reel-card').forEach(function (card) {
    var video = card.querySelector('video.sify-video');
    var btn = card.querySelector('.sify-play-btn');
    if (!video || !btn) return;

    function syncState() {
      var icon = btn.querySelector('i');
      if (icon) {
        icon.className = video.paused ? 'ph ph-play' : 'ph ph-pause';
      }
      btn.classList.toggle('is-paused', video.paused);
    }

    btn.addEventListener('click', function () {
      if (video.paused) {
        /* Ensure sources are attached — user may click before the
           IntersectionObserver fires (e.g. fast scroll, slider). */
        if (window.SSLazyVideo) {
          window.SSLazyVideo.play(video);
        } else {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    syncState();
  });
})();

/* ============================================================
   COLLAPSIBLE CONTENT — FAQ Show More Toggle
   Scoped per section via data-section-id
   Only fires when .faq-toggle-btn exists (hidden_count > 0)
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('.faq-toggle-btn').forEach(function (btn) {
    var sectionId   = btn.getAttribute('data-section-id');
    var hiddenCount = parseInt(btn.getAttribute('data-hidden-count'), 10) || 0;
    var showLabel   = btn.getAttribute('data-show-label');
    var hideLabel   = btn.getAttribute('data-hide-label') || 'Show Less';
    var extra       = document.getElementById('faqExtra-' + sectionId);
    var textEl      = btn.querySelector('.faq-toggle-text');

    if (!extra || !textEl) return;

    if (!showLabel) {
      showLabel = 'Show ' + hiddenCount + ' More Question' + (hiddenCount !== 1 ? 's' : '');
    }

    btn.addEventListener('click', function () {
      var isOpen = extra.classList.contains('is-open');

      extra.classList.toggle('is-open');
      extra.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      textEl.textContent = isOpen ? showLabel : hideLabel;
    });
  });
})();

/* ============================================================
   COLLECTION HERO BANNER — Category Pill Filter
   Toggles active state on hero pills. Dispatches a custom
   event 'chb:filter' so downstream sections (product grid)
   can react to the selected category.
   Clicking a pill also scrolls to the collection body.
   ============================================================ */
(function () {
  'use strict';

  var pills = document.querySelectorAll('.chb-cat');
  if (!pills.length) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      var category = pill.getAttribute('data-hero-cat') || 'all';

      /* Dispatch custom event for other sections to listen */
      document.dispatchEvent(new CustomEvent('chb:filter', {
        detail: { category: category }
      }));

      /* Scroll to collection body if it exists */
      var body = document.querySelector('.collection-body, .main-collection-product-grid');
      if (body) {
        body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

/* ============================================================
   COLLECTION PAGE — Grid View Toggle
   Switches product grid between 2, 3, and 4 columns on desktop.
   Updates the grid class on #product-grid.
   ============================================================ */
(function () {
  'use strict';

  var toggleBtns = document.querySelectorAll('.col-grid-toggle__btn');
  var grid = document.getElementById('product-grid');
  if (!toggleBtns.length || !grid) return;

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cols = btn.getAttribute('data-grid-cols');

      /* Update active state */
      toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      /* Remove existing column classes and add the new one */
      grid.className = grid.className.replace(/grid--\d-col-desktop/g, '');
      grid.classList.add('grid--' + cols + '-col-desktop');
    });
  });
})();

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.chb-cat');
    if (!pill) return;
    var group = pill.closest('.chb-cats');
    if (!group) return;
    group.querySelectorAll('.chb-cat').forEach(function (p) {
      p.classList.remove('is-active');
    });
    pill.classList.add('is-active');
  });
})();
